import { gql } from "@outschool/ui-apollo";

export const AttachmentFragment = gql`
  fragment AttachmentFragment on Attachment {
    uid
    fileUrl
    videoThumbnailUrl
    file {
      filename
      mimetype
      size
      url
      thumbUrl
    }
    conversionStatus
    created_at
  }
`;
